const eventClickShare = (params, share, categoryEntry) => {
  const typeWeb = params?.category?.type;
  const serviceType = typeWeb === 'package' || typeWeb === 'coupon' ? true : false;
  if (typeof window !== 'undefined' && params && share) {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `${
        typeWeb == 'package'
          ? 'paket_servis'
          : typeWeb == 'coupon'
            ? 'kupon_servis'
            : typeWeb === 'news'
              ? 'article'
              : typeWeb === 'productknowledge'
                ? 'review'
                : typeWeb
      }_share_button`,
      eventCategory: `${
        typeWeb == 'package'
          ? 'paket servis'
          : typeWeb == 'coupon'
            ? 'kupon servis'
            : typeWeb === 'news'
              ? 'article'
              : typeWeb === 'productknowledge'
                ? 'review produk'
                : typeWeb
      } page${typeWeb === 'promo' || typeWeb === 'news' ? ' events' : ''}`,
      eventAction: `share ${
        typeWeb == 'package'
          ? 'paket servis'
          : typeWeb == 'coupon'
            ? 'kupon servis'
            : typeWeb === 'news'
              ? 'article'
              : typeWeb === 'productknowledge'
                ? 'review produk'
                : typeWeb
      } - ${share}`,
      eventLabel: `${categoryEntry ? categoryEntry : params?.contentCategory?.name?.toLowerCase() || 'not available'} - ${
        serviceType
          ? params?.serviceProductTitle?.toLowerCase() || 'not available'
          : params?.titlePage?.toLowerCase() || 'not available'
      }`,
      carModel: params?.carName?.toLowerCase(),
    });
  }
};
export default eventClickShare;
